import { CompanyEnums } from "./../types/CompanySchema";
import { SignatureData } from "../types/SignatureData";
import { buildEmlFile } from "./buildEmlFile";

const ejsTemplates = require.context("../assets/templates/");

const getEJS = (key: CompanyEnums) => {
  try {
    return ejsTemplates<(config: unknown) => string>(`./${key}.ejs`);
  } catch (e) {
    console.log(e);
  }
};

const htmlFileHeader = "data:text/html;charset=utf-8,";
const emlFileHeader = "data:message/rfc822;charset=utf-8,";

/** Renders the company template to plain HTML, the source for every output format. */
const renderTemplateHtml = (data: SignatureData): string | undefined => {
  const { company, ...options } = data;

  const ejsFileName = getEJS(company!);

  if (!ejsFileName) {
    return undefined;
  }

  try {
    return ejsFileName(options);
  } catch (e) {
    console.log(e);

    return undefined;
  }
};

/** Downloadable .html file, to be pasted into Outlook on Windows. */
const generateTemplate = async (
  data: SignatureData
): Promise<string | undefined> => {
  const parsedTemplate = renderTemplateHtml(data);

  if (!parsedTemplate) {
    return undefined;
  }

  return htmlFileHeader + encodeURIComponent(parsedTemplate);
};

/** Downloadable .eml file, to be opened and copied from Apple Mail on macOS. */
const generateEmlTemplate = async (
  data: SignatureData
): Promise<string | undefined> => {
  const parsedTemplate = renderTemplateHtml(data);

  if (!parsedTemplate) {
    return undefined;
  }

  const eml = buildEmlFile(parsedTemplate, data.name || "");

  return emlFileHeader + encodeURIComponent(eml);
};

export { generateTemplate, generateEmlTemplate, renderTemplateHtml };
